import { Check, Users, Sparkles } from "lucide-react";
import { formatINR } from "../../lib/api";
import { useBooking } from "../../context/BookingContext";

export const Ribbon = ({ children, className = "" }) => (
  <span className={`ribbon inline-block px-7 py-2 font-serif text-lg font-semibold uppercase tracking-[0.25em] text-white drop-shadow-sm ${className}`}>
    {children}
  </span>
);

export const PackageCard = ({ group, t, price }) => {
  const { book } = useBooking();
  const popular = t.popular;
  return (
    <article
      className={`group relative flex h-full flex-col rounded-[28px] border p-7 pt-12 transition-[transform,box-shadow] duration-500 hover:-translate-y-2 sm:p-8 sm:pt-12 ${
        popular
          ? "border-gold bg-gradient-to-b from-peach-soft to-white shadow-[0_40px_80px_-40px_rgba(139,122,79,0.7)] lg:-mt-6 lg:mb-6"
          : "border-gold/25 bg-white hover:shadow-[0_30px_60px_-35px_rgba(74,74,66,0.45)]"
      }`}
      data-testid={`package-card-${group.id}-${t.tier.toLowerCase()}`}
    >
      <div className="absolute -top-5 left-1/2 -translate-x-1/2">
        <Ribbon>{t.tier}</Ribbon>
      </div>
      {popular && (
        <span className="absolute right-5 top-5 inline-flex items-center gap-1 rounded-full bg-gold px-3 py-1 text-[10px] font-medium uppercase tracking-[0.2em] text-cream" data-testid={`popular-badge-${group.id}`}>
          <Sparkles className="h-3 w-3" /> Most Popular
        </span>
      )}
      <p className="mt-6 text-center font-serif text-5xl text-ink" data-testid={`package-price-${t.key}`}>{formatINR(price)}</p>
      <p className="mt-2 flex items-center justify-center gap-2 text-xs uppercase tracking-[0.22em] text-gold-dark">
        <Users className="h-3.5 w-3.5" /> {t.crew.length} Person Team
      </p>
      <div className="mt-5 flex flex-wrap justify-center gap-1.5">
        {t.crew.map((c) => (
          <span key={c} className="rounded-full bg-olive-light px-3 py-1 text-[11px] text-olive">{c}</span>
        ))}
      </div>
      <div className="gold-line my-7" />
      <ul className="flex-1 space-y-3">
        {t.features.map((f) => (
          <li key={f} className="flex items-start gap-3 text-sm text-ink">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
            {f}
          </li>
        ))}
      </ul>
      <button
        onClick={() => book(`${group.label} – ${t.tier}`, group.label)}
        className={`mt-8 w-full ${popular ? "btn-gold" : "btn-ghost"}`}
        data-testid={`package-book-btn-${t.key}`}
      >
        Book This Package
      </button>
    </article>
  );
};
